import React, { useState, useEffect } from 'react';
import apiClient from '../api/api';
import { FaCheck, FaTimes, FaWallet, FaHistory, FaUser } from 'react-icons/fa';

const AdminWithdrawalsPage = () => {
    const [withdrawals, setWithdrawals] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchWithdrawals = async () => {
        try {
            setLoading(true);
            const res = await apiClient.get('/admin/withdrawals');
            setWithdrawals(res.data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchWithdrawals();
    }, []);

    const handleAction = async (id, action) => {
        if (!window.confirm(`Are you sure you want to ${action} this withdrawal?`)) return;
        
        try {
            await apiClient.put(`/admin/withdrawals/${id}`, { action });
            setWithdrawals(withdrawals.filter(w => w.id !== id));
            alert(`Withdrawal ${action}d.`);
        } catch (err) {
            alert("Failed to process withdrawal.");
        }
    };

    if (loading) return <div className="p-10 text-center font-bold text-slate-500 text-sm">Accessing Payout Queue...</div>;

    return (
        <div className="space-y-8 font-sans">
            <div>
                <h1 className="text-3xl font-black text-slate-900 tracking-tight">Withdrawal Requests</h1>
                <p className="text-slate-500 mt-1 font-medium">Review and process payout requests from workers and buyers.</p>
            </div>

            {withdrawals.length === 0 ? (
                <div className="bg-white rounded-[2rem] border-2 border-dashed border-slate-200 py-32 text-center">
                    <div className="w-20 h-20 bg-slate-50 rounded-full flex items-center justify-center mx-auto mb-4 text-emerald-500">
                        <FaCheck size={30} />
                    </div>
                    <h3 className="text-xl font-bold text-slate-800">All caught up!</h3>
                    <p className="text-slate-400 font-medium">No pending withdrawal requests found.</p>
                </div>
            ) : (
                <div className="bg-white rounded-[2.5rem] shadow-sm border border-slate-200 overflow-hidden">
                    <table className="w-full text-left">
                        <thead className="bg-slate-50 border-b border-slate-100">
                            <tr>
                                <th className="px-8 py-5 text-[10px] font-black text-slate-400 uppercase tracking-widest">User & Request</th>
                                <th className="px-8 py-5 text-[10px] font-black text-slate-400 uppercase tracking-widest">Method & Info</th>
                                <th className="px-8 py-5 text-[10px] font-black text-slate-400 uppercase tracking-widest text-right">Amount</th>
                                <th className="px-8 py-5 text-[10px] font-black text-slate-400 uppercase tracking-widest text-center">Actions</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-100">
                            {withdrawals.map((w) => (
                                <tr key={w.id} className="hover:bg-slate-50 transition-colors group">
                                    <td className="px-8 py-6">
                                        <div className="flex items-center gap-3">
                                            <div className="w-10 h-10 rounded-xl bg-slate-100 flex items-center justify-center text-slate-400 font-black">
                                                {w.wallet?.profile?.name?.charAt(0) || 'U'}
                                            </div>
                                            <div>
                                                <p className="text-sm font-black text-slate-800">{w.wallet?.profile?.name || 'Unknown User'}</p>
                                                <p className="text-[10px] text-slate-400 font-bold uppercase">{new Date(w.createdAt).toLocaleDateString()}</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="px-8 py-6">
                                        <div className="text-xs font-bold text-slate-600 leading-relaxed">
                                            {w.description}
                                        </div>
                                    </td>
                                    <td className="px-8 py-6 text-right">
                                        <p className="text-lg font-black text-slate-800">৳{w.amount.toLocaleString()}</p>
                                        <p className="text-[10px] text-slate-400 font-bold uppercase">{w.currency}</p>
                                    </td>
                                    <td className="px-8 py-6">
                                        <div className="flex justify-center gap-2">
                                            <button 
                                                onClick={() => handleAction(w.id, 'approve')}
                                                className="p-3 bg-emerald-50 text-emerald-600 rounded-xl hover:bg-emerald-600 hover:text-white transition-all shadow-sm"
                                                title="Approve & Complete"
                                            >
                                                <FaCheck />
                                            </button>
                                            <button 
                                                onClick={() => handleAction(w.id, 'reject')}
                                                className="p-3 bg-red-50 text-red-500 rounded-xl hover:bg-red-600 hover:text-white transition-all shadow-sm"
                                                title="Reject & Refund to Wallet"
                                            >
                                                <FaTimes />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default AdminWithdrawalsPage;
